import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Button,
  Image,
  Platform,
  Modal,
  FlatList,
  ActivityIndicator,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useContext, useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import { axiosWithCredentials } from "../../api/axios";
import AppContext from "../../context/AppContext";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import VerifyEmail from "./VerifyEmail";
import meezalogo from "../../../assets/me_red.png";
import { useNavigation } from "@react-navigation/native";
import NetInfo from "@react-native-community/netinfo";
import EnterEmailScreen from "../forgotResetPassword/EnterEmailScreen";
import AsyncStorage from "@react-native-async-storage/async-storage";

import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import Icon from "react-native-vector-icons/Ionicons";
import * as Device from "expo-device";
import * as Application from "expo-application";
import { getPersistentDeviceId } from "../../utils/getPersistentDeviceId";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const LoginScreen = () => {
  const {
    setAuth,
    setActivitySettings,
    setAuthLocalStorage,
    setUserToken,
    setUserInfo,
    reverifyUser,
  } = useContext(AppContext);

  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isUsernameFocused, setIsUsernameFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isUsernameSelected, setIsUsernameSelected] = useState(false);
  const [isEmailSelected, setIsEmailSelected] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyEmailVisible, setIsVerifyEmailVisible] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isPhoneNumberSelected, setIsPhoneNumberSelected] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [showEmailEntry, setShowEmailEntry] = useState(false);

  const [phonenumber, setPhonenumber] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [selected, setSelectedTagItem] = useState();

  const [showPassword, setShowPassword] = useState(false);

  const [failedAttempts, setFailedAttempts] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutEndTime, setLockoutEndTime] = useState(null);

  const navigate = useNavigation();

  const MAX_ATTEMPTS = 3;
  const LOCKOUT_DURATION = 5 * 60 * 1000; // 2 minutes

  const tags = [{ tag: "email" }, { tag: "username" }];
  // const tags = [{ "tag": "phone-number" }, { "tag": "username" }, { "tag": "email" }];
  //console.log()

  useEffect(() => {
    const loadLockoutData = async () => {
      const attempts = await AsyncStorage.getItem("failedAttempts");
      const lastFailedTime = await AsyncStorage.getItem("lastFailedTime");

      if (attempts) setFailedAttempts(parseInt(attempts, 10));

      if (lastFailedTime) {
        const lastAttemptTime = parseInt(lastFailedTime, 10);
        const currentTime = Date.now();

        if (currentTime - lastAttemptTime < LOCKOUT_DURATION) {
          setIsLocked(true);
          setLockoutEndTime(lastAttemptTime + LOCKOUT_DURATION);
        } else {
          await AsyncStorage.setItem("failedAttempts", "0"); // Reset after lockout
          setFailedAttempts(0);
          setIsLocked(false);
        }
      }
    };

    loadLockoutData();
  }, []);

  useEffect(() => {
    if (isLocked) {
      const interval = setInterval(() => {
        const remainingTime = lockoutEndTime - Date.now();
        if (remainingTime <= 0) {
          setIsLocked(false);
          setFailedAttempts(0);
          AsyncStorage.multiRemove(["failedAttempts", "lastFailedTime"]);
          clearInterval(interval);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isLocked, lockoutEndTime]);

  useEffect(() => {
    if (isUsernameSelected) {
      setEmail("");
    } else if (isEmailSelected) {
      setUsername("");
    }
  }, [isUsernameSelected, isEmailSelected]);

  const handleUsername = (text) => {
    setUsername(text);
  };
  const handleEmail = (text) => {
    setEmail(text);
    setValidEmail(validateEmail(text));
  };
  const handlePassword = (text) => {
    setPassword(text);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateEmailForms = () => {
    if (email === "") {
      setIsEmailFocused(true);
    } else if (validEmail === false) {
      setErrorMessage("Enter a valid email address");
      setIsErrorCompVisible(true);
    } else {
      handleSubmitLogin();
    }
  };

  const validateUsernameForms = () => {
    ////console.log('USERNAME SIDEDD')

    if (isUsernameSelected && username === "") {
      // if (username === '') {
      ////console.log('USERNAME SIDE')
      setIsUsernameFocused(true);
    } else {
      handleSubmitLogin();
    }
  };

  // const handleSubmitLogin = async (e) => {

  //   ////console.log("Making login request to:", axiosWithCredentials.defaults.baseURL)

  //   const state = await NetInfo.fetch();
  //   if (!state.isConnected) {
  //     ////console.log("No internet. Skipping API request.");
  //     setErrorMessage("No Internet, check your network connection.")
  //     setIsErrorCompVisible(true)
  //     return;
  //   }

  //   if (password === '') {
  //     setIsPasswordFocused(true)
  //   } else {

  //     setIsLoading(true)
  //     try {

  //       const res = await axiosWithCredentials.post('/auth', { email, username, password })

  //       const accessToken = res?.data?.accessToken
  //       const refreshToken = res?.data?.refreshToken
  //       const userInfo = res?.data?.user_info
  //       const firstname = res?.data?.firstname

  //       ////console.log('accessToken', accessToken)
  //       ////console.log('refreshToken', refreshToken)
  //       ////console.log('userInfor', userInfo)
  //       ////console.log('firstname', firstname)

  //       setAuthLocalStorage({ refreshToken })
  //       setAuth({ accessToken })
  //       setUserToken(refreshToken)
  //       setUserInfo(userInfo)
  //       //setFirstName(firstname)

  //       await AsyncStorage.multiRemove(['failedAttempts', 'lastFailedTime']);
  //       setFailedAttempts(0);
  //       setIsLocked(false);

  //       ////console.log('LogIn successful !!!')

  //     } catch (error) {

  //       if (error.response && error.response.status === 401) {
  //         setErrorMessage(error.response.data.message)
  //         setIsErrorCompVisible(true)

  //         const newAttempts = failedAttempts + 1;
  //         await AsyncStorage.setItem('failedAttempts', newAttempts.toString());
  //         setFailedAttempts(newAttempts);

  //         if (newAttempts >= MAX_ATTEMPTS) {
  //           const lockTime = Date.now();
  //           await AsyncStorage.setItem('lastFailedTime', lockTime.toString());
  //           setIsLocked(true);
  //           setLockoutEndTime(lockTime + LOCKOUT_DURATION);
  //           // setErrorMessage('Too many failed attempts', `Login is locked for 5 minutes.`)
  //           setErrorMessage('Too many failed attempts', `Login is locked try again in  5 minutes.`)

  //           setIsErrorCompVisible(true)

  //         } else {
  //           // Alert.alert()
  //           setErrorMessage(newAttempts > 1 ? `Login Failed (${newAttempts}/${MAX_ATTEMPTS})` : error.response.data.message)
  //           setIsErrorCompVisible(true)

  //         }

  //         ////console.log('HERE AGAIN')
  //         return
  //       } else {
  //         setErrorMessage("Login error!!")
  //         setIsErrorCompVisible(true)
  //       }

  //       ////console.log('LogIn Error', error)

  //     } finally {
  //       setIsLoading(false)
  //     }

  //   }

  // }

  const handleSubmitLogin = async (e) => {
    ////console.log("Making login request to:", axiosWithCredentials.defaults.baseURL);
    setIsLoading(true);
    const deviceId = await getPersistentDeviceId(username || email);

    ////console.log("Device ID before login:", deviceId);

    const state = await NetInfo.fetch();
    if (!state.isConnected) {
      ////console.log("No internet. Skipping API request.");
      setErrorMessage("No Internet, check your network connection.");
      setIsErrorCompVisible(true);
      return;
    }

    if (password === "") {
      setIsPasswordFocused(true);
      return;
    }

    try {
      const res = await axiosWithCredentials.post("/auth", {
        email,
        username,
        password,
        deviceId,
      });

      await AsyncStorage.setItem("hasAccount", "true");

      const accessToken = res?.data?.accessToken;
      const hasPendingPrepaidOrder = res?.data?.hasPendingPrepaidOrder;
      const userInfo = res?.data?.user_info;
      const activitySettings = res?.data?.activitySettings;
      const isProfileComplete = res?.data?.isProfileComplete;

      // UPDATE: Clean, minimal memory tracking footprint
      setAuth({ accessToken, isProfileComplete, hasPendingPrepaidOrder });
      setActivitySettings(activitySettings);
      setUserInfo(userInfo);
      reverifyUser();

      // const accessToken = res?.data?.accessToken;
      // const refreshToken = res?.data?.refreshToken;
      // const userInfo = res?.data?.user_info;
      // const firstname = res?.data?.firstname;
      // const activitySettings = res?.data?.activitySettings;

      // // Store tokens & user info
      // setAuthLocalStorage({ refreshToken });
      // setAuth({ accessToken });
      // setActivitySettings(activitySettings);
      // setUserToken(refreshToken);
      // setUserInfo(userInfo);
      // reverifyUser();

      // Reset UI state
      setFailedAttempts(0);
      setIsLocked(false);

      ////console.log('LogIn successful !!!');
    } catch (error) {
      if (error.response) {
        const { type, message } = error.response.data;

        if (type === "LOCKED") {
          // Backend says account is locked
          setErrorMessage(message);
          setIsErrorCompVisible(true);
          setIsLocked(true);
          return;
        }

        if (type === "INVALID_PASSWORD") {
          // Wrong password but not locked
          setErrorMessage(message);
          setIsErrorCompVisible(true);
          return;
        }

        // Any other backend error (e.g. unauthorized, missing fields, etc.)
        ////console.log('ErrorType', type)
        setErrorMessage(message || "Login failed.");
        setIsErrorCompVisible(true);
      } else {
        // Network or unexpected error
        setErrorMessage("Login error!! Please try again.");
        setIsErrorCompVisible(true);
      }

      ////console.log('LogIn Error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getRemainingTime = () => {
    if (!lockoutEndTime) return null;
    const remaining = lockoutEndTime - Date.now();
    return remaining > 0 ? Math.ceil(remaining / 1000) : null;
  };

  const handleSelectedItems = (selectedLogInMethod) => {
    setSelectedTagItem(selectedLogInMethod);
    // if (selectedLogInMethod === "phone-number") {
    //   setIsPhoneNumberSelected(true)
    //   setIsEmailSelected(false)
    //   setIsUsernameSelected(false)
    // } else
    if (selectedLogInMethod === "username") {
      setIsUsernameSelected(true);
      setIsPhoneNumberSelected(false);
      setIsEmailSelected(false);
    } else if (selectedLogInMethod === "email") {
      setIsEmailSelected(true);
      setIsUsernameSelected(false);
      setIsPhoneNumberSelected(false);
    }
  };

  const handleForgotPassword = () => {
    setShowEmailEntry(true);
  };

  return (
    <View
      style={{
        display: "flex",
        //marginTop: dynamicSpacing(18),
        backgroundColor: "white",
        height: "100%",
        //padding: dynamicSpacing(15)
      }}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        componentStyle={{ height: "100%" }}
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: dynamicSpacing(100),
        }}
      >
        {/* paddingBottom: dynamicSpacing(100) */}

        <View
          style={{
            padding: dynamicSpacing(15),
            paddingTop: dynamicSpacing(150),
            height: "100%",
            backgroundColor: "white",
          }}
        >
          <View style={styles.logoIconBox}>
            <Image
              source={meezalogo} // replace with your logo path
              style={styles.logoImage}
            />
            <Text
              style={{
                fontSize: dynamicSize(16),
                fontWeight: "600",
                color: Colours.DARKGRAY,
                textAlign: "center",
              }}
            >
              Meeza.
            </Text>
          </View>

          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: dynamicSpacing(15),
              // height: dynamicSize(40),
              marginTop: dynamicSpacing(80),
              // backgroundColor: 'yellow',
              paddingTop: dynamicSpacing(20),
              paddingBottom: dynamicSpacing(20),
            }}
          >
            <Text
              style={{
                color: Colours.DARKLIGHTGRAY,
                fontSize: dynamicFontSize(13),
                fontFamily: "Sen-Regular",
              }}
            >
              Login with
            </Text>
            <FlatList
              data={tags}
              horizontal={true}
              showsHorizontalScrollIndicator={false}
              renderItem={({ item, index }) => (
                <TouchableOpacity
                  style={{ marginRight: dynamicSpacing(5) }}
                  onPress={() => handleSelectedItems(item.tag)}
                >
                  <Text
                    style={[
                      {
                        fontFamily: "Sen-Regular",
                        fontSize: dynamicFontSize(12),
                      },
                      selected == item.tag ? styles.selectedTagItem : styles.unselectedTagItem,
                    ]}
                  >
                    {item.tag}
                  </Text>
                </TouchableOpacity>
              )}
            />
          </View>

          {isUsernameSelected && (
            <View style={styles.createPullFormContainer}>
              <View style={styles.textAndTxtInput}>
                <Text
                  style={{
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(12),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  USERNAME
                </Text>
                <AppTextInput
                  style={[styles.textInputStyle, isUsernameFocused && styles.focusedBorder]}
                  placeholder="Username"
                  fontSize={15}
                  // keyboardType="email-address"
                  onFocus={() => setIsUsernameFocused(true)}
                  onBlur={() => setIsUsernameFocused(false)}
                  onChangeText={handleUsername}
                />
              </View>
              <View style={styles.textAndTxtInput}>
                <Text
                  style={{
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(12),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  PASSWORD
                </Text>
                <AppTextInput
                  style={[styles.textInputStyle, isPasswordFocused && styles.focusedBorder]}
                  placeholder="Password"
                  fontSize={dynamicFontSize(15)}
                  secureTextEntry={!showPassword}
                  // secureTextEntry={showPassword ? false : true} // Make it a password input
                  onFocus={() => setIsPasswordFocused(true)}
                  onBlur={() => setIsPasswordFocused(false)}
                  onChangeText={handlePassword}
                  // rightButton={<Icon name={showPassword ? 'eye-off' : 'eye'} onPress={() => setShowPassword(!showPassword)} />}
                />
                <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
                  <Icon
                    name={showPassword ? "eye-off-outline" : "eye-outline"}
                    size={dynamicSize(22)}
                    color={Colours.PRIMARY_LIGHT}
                    style={{
                      marginLeft: dynamicSpacing(10),
                      marginTop: dynamicSize(10),
                    }}
                  />
                </TouchableOpacity>
              </View>
              <TouchableOpacity
                style={[
                  styles.buttonGray,
                  {
                    backgroundColor: isLocked ? Colours.PRIMARY_LIGHTER : Colours.PRIMARY,
                  },
                ]}
                onPress={() => validateUsernameForms()}
                disabled={isLocked || isLoading}
              >
                {isLoading ? (
                  <ActivityIndicator size="small" color="white" />
                ) : (
                  <Text
                    style={{
                      color: "white",
                      fontSize: dynamicFontSize(15),
                      fontFamily: "Sen-Bold",
                    }}
                  >
                    LOGIN
                  </Text>
                )}
              </TouchableOpacity>
              {isLocked && (
                <Text
                  style={{
                    color: Colours.PRIMARY_LIGHT,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                    marginTop: dynamicSpacing(12),
                  }}
                >
                  Login locked. Try again in {getRemainingTime()} seconds.
                </Text>
              )}

              <TouchableOpacity
                style={{ display: "flex", alignItems: "center" }}
                onPress={handleForgotPassword}
              >
                <Text
                  style={{
                    marginTop: dynamicSpacing(7),
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                  }}
                >
                  Forgot Password?
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ display: "flex", alignItems: "center" }}
                onPress={() => navigate.push("sign_in")}
              >
                <Text
                  style={{
                    marginTop: dynamicSpacing(7),
                    color: Colours.PRIMARY_LIGHT,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                  }}
                >
                  Signup
                </Text>
              </TouchableOpacity>
            </View>
          )}

          {isEmailSelected && (
            <View style={styles.createPullFormContainer}>
              <View style={styles.textAndTxtInput}>
                <Text
                  style={{
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(12),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  EMAIL
                </Text>
                <AppTextInput
                  style={[styles.textInputStyle, isEmailFocused && styles.focusedBorder]}
                  placeholder="Email"
                  fontSize={15}
                  // keyboardType="email-address"
                  onFocus={() => setIsEmailFocused(true)}
                  onBlur={() => setIsEmailFocused(false)}
                  onChangeText={handleEmail}
                />
              </View>
              <View style={styles.textAndTxtInput}>
                <Text
                  style={{
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(12),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  PASSWORD
                </Text>
                <AppTextInput
                  style={[styles.textInputStyle, isPasswordFocused && styles.focusedBorder]}
                  placeholder="Password"
                  fontSize={dynamicFontSize(15)}
                  secureTextEntry={!showPassword}
                  // secureTextEntry={showPassword ? false : true} // Make it a password input
                  onFocus={() => setIsPasswordFocused(true)}
                  onBlur={() => setIsPasswordFocused(false)}
                  onChangeText={handlePassword}
                  // rightButton={<Icon name={showPassword ? 'eye-off' : 'eye'} onPress={() => setShowPassword(!showPassword)} />}
                />
                <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
                  <Icon
                    name={showPassword ? "eye-off-outline" : "eye-outline"}
                    size={dynamicSize(22)}
                    color={Colours.PRIMARY_LIGHT}
                    style={{
                      marginLeft: dynamicSpacing(10),
                      marginTop: dynamicSize(10),
                    }}
                  />
                </TouchableOpacity>
              </View>
              <TouchableOpacity
                style={[
                  styles.buttonGray,
                  {
                    backgroundColor: isLocked ? Colours.PRIMARY_LIGHTER : Colours.PRIMARY,
                  },
                ]}
                onPress={() => validateEmailForms()}
                disabled={isLocked || isLoading}
              >
                {isLoading ? (
                  <ActivityIndicator size="small" color="white" />
                ) : (
                  <Text
                    style={{
                      color: "white",
                      fontSize: dynamicFontSize(15),
                      fontFamily: "Sen-Bold",
                    }}
                  >
                    LOGIN
                  </Text>
                )}
              </TouchableOpacity>
              {isLocked && (
                <Text
                  style={{
                    color: Colours.PRIMARY_LIGHT,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                    marginTop: dynamicSpacing(12),
                  }}
                >
                  Login locked. Try again in {getRemainingTime()} seconds.
                </Text>
              )}

              <TouchableOpacity
                style={{ display: "flex", alignItems: "center" }}
                onPress={handleForgotPassword}
              >
                <Text
                  style={{
                    marginTop: dynamicSpacing(7),
                    color: Colours.DARKGRAY,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                  }}
                >
                  Forgot Password?
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ display: "flex", alignItems: "center" }}
                //onPress={() => navigate.push("sign_up")}
                onPress={() => navigate.push("phone_number")}
              >
                <Text
                  style={{
                    marginTop: dynamicSpacing(7),
                    color: Colours.PRIMARY_LIGHT,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                    textAlign: "center",
                  }}
                >
                  Signup
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      </ScrollView>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>

      <Modal visible={isVerifyEmailVisible} animationType="fade">
        <VerifyEmail
          email={email}
          username={username}
          handleSubmitLogin={handleSubmitLogin}
          hideModal={() => {
            // setUsername('')
            // setEmail('')
            // setPassword('')
            setIsVerifyEmailVisible(false);
          }}
          //code={code}
          // onClose={() => setIsErrorCompVisible(false)}
        />
      </Modal>

      <Modal visible={showEmailEntry} animationType="fade">
        <EnterEmailScreen
          hideModal={() => setShowEmailEntry(false)}
          setShowEmailEntry={setShowEmailEntry}
        />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  createPullFormContainer: {
    display: "flex",
    paddingTop: 0,
  },
  textAndTxtInput: {
    display: "flex",
    marginTop: dynamicSpacing(15),
  },

  textInputStyle: {
    height: dynamicSize(50),
    marginTop: dynamicSpacing(10),
    // gap: 10,
    padding: dynamicSpacing(15),
    borderWidth: dynamicSpacing(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    // backgroundColor: Colours.LIGHTGRAY,
  },

  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  buttonGray: {
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(15),
    marginTop: dynamicSpacing(15),
    // width: 340,
    height: dynamicSize(60),
  },

  userImage: {
    width: dynamicSize(55),
    height: dynamicSize(55),
    borderRadius: dynamicSize(99),
    marginBottom: dynamicSpacing(3),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    marginTop: dynamicSpacing(10),
    backgroundColor: Colours.LIGHTGRAY,
  },
  topHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    //   backgroundColor: "#12ff34",
    alignItems: "center",
    padding: dynamicSpacing(15),
    paddingTop: dynamicSpacing(40),
  },
  topHeaderContainStyle: {
    display: "flex",
    flexDirection: "column",
    // marginTop: 15,
  },
  selectedTagItem: {
    padding: dynamicSpacing(5),
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    backgroundColor: Colours.PRIMARY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSpacing(10),
    color: "#FFFFFF",
  },
  unselectedTagItem: {
    padding: dynamicSpacing(5),
    borderWidth: 1,
    // borderColor: Colours.PRIMARY,
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSpacing(10),
    //color: Colours.PRIMARY,
    color: Colours.DARKLIGHTGRAY,
  },
  logoIconBox: {
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(16),
    padding: dynamicSpacing(16),
    alignItems: "center",
    justifyContent: "center",
    // marginHorizontal: dynamicSpacing(20),
    marginTop: dynamicSpacing(20),
  },
  logoImage: {
    width: dynamicSize(70),
    height: dynamicSize(70),
    marginBottom: dynamicSpacing(8),
    borderRadius: dynamicSize(16),
    // resizeMode: 'contain',
  },
});

export default LoginScreen;
